import React from 'react';
import Counter from '../mui/counter.jsx';
import classnames from 'classnames';
import helper from '../../helper/dish-helper';
import shallowCompare from 'react-addons-shallow-compare';
import { formatMessage } from '../../intl/helper';
import FormattedMessage from '../../intl/formatted-message';
import dishMenuMessages from '../../intl/messages/dish-menu';
import buryingPoint, { getPageTypeFromUrl } from '../../helper/divolte/register-divolte';
import getBrandConfig from '../../helper/configs/brand';

import './build-order-btn.scss';

class BuildOrderBtn extends React.Component {
  static displayName = 'BuildOrderBtn';
  static proptypes = {
    dishData: React.PropTypes.object,
    sameRuleDishList: React.PropTypes.array,
    isClear: React.PropTypes.bool,
    changeShowDataItems: React.PropTypes.object,
    showHandleInput: React.PropTypes.func,
    showHandleDishCount: React.PropTypes.func,
    onBtnTap: React.PropTypes.func,
    onlyAddCounter: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      showCount: props.dishData.order,
    };
    this.incrementStore = 0;
  }

  // snail
  componentWillReceiveProps(nextProps) {
    if (nextProps.dishData) {
      this.setState({ showCount: nextProps.dishData.order });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  /**
   * 埋点购物车
   */
  buryingPointAddToCart(dish = {}) {
    try {
      const pageType = getPageTypeFromUrl();
      buryingPoint.send('AddToShoppingCart', { commodityId: dish.id || '', pageType });
    } catch (ex) {
      console.error(ex);
    }
  }

  onBtnTouchTap(newCount, increment) {
    const { onBtnTap, dishData } = this.props;
    if (newCount < 0) return;
    this.incrementStore += increment;
    this.setState({ showCount: newCount });
    this.delayTimer && clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      const incrementFinally = this.incrementStore;
      if (incrementFinally > 0) {
        this.buryingPointAddToCart(dishData);
      }
      this.incrementStore = 0;
      onBtnTap(newCount, incrementFinally, dishData);
    }, 100);
  }

  buildOrderBtn(dishData, sameRuleDishList, isClear) {
    const { onlyAddCounter } = this.props;
    const { showCount } = this.state;
    // 表示被沽清
    if (isClear) {
      return (
        <span className="dish-item-soldout-text">
          <FormattedMessage {...dishMenuMessages.soldout} />
        </span>
      );
    }

    if (helper.isSingleDishWithoutProps(dishData) && !sameRuleDishList) {
      const { minimum, msg } = helper.getMustOrderMinNum(dishData);
      return (
        <Counter
          changeShowDataItems={this.props.changeShowDataItems}
          count={showCount}
          onCountChange={(newCount, increment) => this.onBtnTouchTap(newCount, increment)}
          step={dishData.stepNum}
          showHandleInput={this.props.showHandleInput}
          dishItem={dishData}
          soldoutClassName="dish-item-soldout-text"
          showHandleDishCount={this.props.showHandleDishCount}
          onlyAddCounter={onlyAddCounter}
          minimum={showCount > 0 ? minimum : 0}
          msg={msg}
          ifShowToolTip
        />
      );
    }

    const dishes = sameRuleDishList || [dishData];
    const count = helper.getDishesCount(dishes);
    const { brandType } = this.context;
    const title = Array.isArray(dishData.groups)
      ? getBrandConfig(brandType, 'dish-menu.select-child-dish', formatMessage(dishMenuMessages.choseChildDish))
      : formatMessage(dishMenuMessages.choseSpecification);

    let countStyle;
    if (count < 10) {
      countStyle = { width: '16px' };
    } else if (count >= 10 && count <= 99) {
      countStyle = { width: '21px' };
    } else {
      countStyle = { width: '27px' };
    }
    return (
      <div className="counter">
        <button className="btn--ellips btn-choose-property" onTouchTap={(newCount, increment) => this.onBtnTouchTap(newCount, increment)}>
          {title}
          {count > 0 ? (
            <span className={classnames('build-order--counter counter-special', { 'counter-special--modify': count > 99 })} style={countStyle}>
              {count > 99 ? '99+' : count}
            </span>
          ) : (
            false
          )}
        </button>
      </div>
    );
  }

  render() {
    const { dishData, sameRuleDishList, isClear } = this.props;
    const buildOrderBtn = this.buildOrderBtn(dishData, sameRuleDishList, isClear);
    return <div>{buildOrderBtn}</div>;
  }
}

export default BuildOrderBtn;



// WEBPACK FOOTER //
// ./src/component/dish-menu/build-order-btn.jsx